module.exports = __webpack_public_path__ + "static/wholesale-full-width-banner-e1f731e0fe1e39d01835e501b4c2b124.png";